var installedModules = {};
var moduleToHandlerMapping = {
	77059: {
		getter: function() { return __webpack_require__.e(1933).then(function() { return function() { return __webpack_require__(14041); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	18033: {
		getter: function() { return __webpack_require__.e(3144).then(function() { return function() { return __webpack_require__(43144); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	45400: {
		getter: function() { return __webpack_require__.e(1085).then(function() { return function() { return __webpack_require__(31085); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	71238: {
		getter: function() { return __webpack_require__.e(287).then(function() { return function() { return __webpack_require__(2668); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.2.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	69877: {
		getter: function() { return __webpack_require__.e(7768).then(function() { return function() { return __webpack_require__(85387); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	29290: {
		getter: function() { return __webpack_require__.e(3464).then(function() { return function() { return __webpack_require__(23464); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.11.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	99521: {
		getter: function() { return __webpack_require__.e(287).then(function() { return function() { return __webpack_require__(2668); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "*",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	542: {
		getter: function() { return __webpack_require__.e(1242).then(function() { return function() { return __webpack_require__(31242); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	46321: {
		getter: function() { return __webpack_require__.e(3464).then(function() { return function() { return __webpack_require__(23464); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	90359: {
		getter: function() { return __webpack_require__.e(2657).then(function() { return function() { return __webpack_require__(2657); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	58547: {
		getter: function() { return __webpack_require__.e(7128).then(function() { return function() { return __webpack_require__(34747); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	89221: {
		getter: function() { return __webpack_require__.e(4615).then(function() { return function() { return __webpack_require__(66996); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	8287: {
		getter: function() { return __webpack_require__.e(4957).then(function() { return function() { return __webpack_require__(57338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	33443: {
		getter: function() { return __webpack_require__.e(1513).then(function() { return function() { return __webpack_require__(83894); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	27966: {
		getter: function() { return __webpack_require__.e(6014).then(function() { return function() { return __webpack_require__(6014); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	86591: {
		getter: function() { return __webpack_require__.e(1543).then(function() { return function() { return __webpack_require__(21543); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	64404: {
		getter: function() { return __webpack_require__.e(8656).then(function() { return function() { return __webpack_require__(83894); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	19076: {
		getter: function() { return __webpack_require__.e(2234).then(function() { return function() { return __webpack_require__(66996); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	23558: {
		getter: function() { return __webpack_require__.e(9985).then(function() { return function() { return __webpack_require__(34747); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	72286: {
		getter: function() { return __webpack_require__.e(2657).then(function() { return function() { return __webpack_require__(2657); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	33857: {
		getter: function() { return __webpack_require__.e(9985).then(function() { return function() { return __webpack_require__(34747); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	93661: {
		getter: function() { return __webpack_require__.e(2657).then(function() { return function() { return __webpack_require__(2657); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	59743: {
		getter: function() { return __webpack_require__.e(8656).then(function() { return function() { return __webpack_require__(83894); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	35337: {
		getter: function() { return __webpack_require__.e(2234).then(function() { return function() { return __webpack_require__(66996); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	}
};
var initialConsumes = [77059,18033,45400,71238,69877,29290,99521,542,46321,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,93661,64404,19076,23558,72286,33857,93661,64404,19076,23558,72286,33857,64404,19076,23558,72286,59743,64404,19076,23558,72286,35337,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,64404,19076,23558,72286,64404,19076,23558,72286,59743,33857,59743,64404,19076,23558,72286,59743,64404,19076,23558,72286,64404,19076,23558,72286,59743,33857,59743,64404,19076,23558,72286,64404,19076,23558,72286,35337,33857,59743,64404,19076,23558,72286,64404,19076,23558,72286,59743,59743,93661,64404,19076,23558,72286,59743,64404,19076,23558,72286,64404,19076,23558,72286,35337,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,93661,33857,64404,19076,23558,72286,33857,93661,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,93661,64404,19076,23558,72286,59743,64404,19076,23558,72286,33857,64404,19076,23558,72286,93661,33857,64404,19076,23558,72286,93661,33857,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,59743,64404,19076,23558,72286,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,59743,64404,19076,23558,72286,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,59743,64404,19076,23558,72286,93661,64404,19076,23558,72286,33857,64404,19076,23558,72286,59743,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,64404,19076,23558,72286,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,33857,64404,19076,23558,72286,59743,64404,19076,23558,72286,64404,19076,23558,72286,64404,19076,23558,72286,33857,59743,64404,19076,23558,72286,64404,19076,23558,72286,93661,64404,19076,23558,72286,33857,64404,19076,23558,72286,35337,64404,19076,23558,72286,33857,64404,19076,23558,72286];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"58": [
		33857
	],
	"77": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"110": [
		64404,
		19076,
		23558,
		72286,
		59743
	],
	"112": [
		64404,
		19076,
		23558,
		72286
	],
	"194": [
		64404,
		19076,
		23558,
		72286
	],
	"203": [
		64404,
		19076,
		23558,
		72286
	],
	"282": [
		64404,
		19076,
		23558,
		72286
	],
	"315": [
		64404,
		19076,
		23558,
		72286
	],
	"337": [
		64404,
		19076,
		23558,
		72286,
		59743,
		33857
	],
	"455": [
		64404,
		19076,
		23558,
		72286,
		33857,
		93661
	],
	"545": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"576": [
		64404,
		19076,
		23558,
		72286
	],
	"621": [
		64404,
		19076,
		23558,
		72286
	],
	"636": [
		45400,
		71238,
		69877,
		29290,
		99521,
		542,
		46321
	],
	"777": [
		64404,
		19076,
		23558,
		72286
	],
	"809": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"1233": [
		93661
	],
	"1290": [
		93661,
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"1633": [
		64404,
		19076,
		23558,
		72286
	],
	"1635": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"1657": [
		64404,
		19076,
		23558,
		72286
	],
	"1695": [
		33857
	],
	"1728": [
		64404,
		19076,
		23558,
		72286,
		33857,
		93661
	],
	"1856": [
		33857
	],
	"2034": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"2441": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"2448": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"2474": [
		64404,
		19076,
		23558,
		72286
	],
	"2491": [
		35337,
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"2508": [
		64404,
		19076,
		23558,
		72286
	],
	"2668": [
		18033,
		77059
	],
	"2731": [
		64404,
		19076,
		23558,
		72286
	],
	"2977": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"3099": [
		64404,
		19076,
		23558,
		72286,
		59743
	],
	"3267": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"3332": [
		64404,
		19076,
		23558,
		72286
	],
	"3452": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"3454": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"3466": [
		77059
	],
	"3537": [
		93661,
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"3608": [
		35337,
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"3633": [
		77059
	],
	"3704": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"3894": [
		77059
	],
	"3924": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"3988": [
		64404,
		19076,
		23558,
		72286
	],
	"4076": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"4202": [
		33857
	],
	"4226": [
		64404,
		19076,
		23558,
		72286,
		93661,
		33857
	],
	"4586": [
		64404,
		19076,
		23558,
		72286
	],
	"4590": [
		64404,
		19076,
		23558,
		72286,
		59743,
		33857
	],
	"4592": [
		93661,
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"4747": [
		77059
	],
	"4895": [
		64404,
		19076,
		23558,
		72286
	],
	"4911": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5038": [
		77059
	],
	"5120": [
		90359,
		542,
		58547,
		89221,
		8287,
		33443,
		77059,
		27966,
		86591,
		45400
	],
	"5235": [
		33857
	],
	"5286": [
		77059
	],
	"5299": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5304": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5387": [
		77059
	],
	"5410": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"5451": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5540": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5561": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"5567": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"5639": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5774": [
		35337,
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5797": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"5807": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"6137": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"6147": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"6485": [
		64404,
		19076,
		23558,
		72286
	],
	"6751": [
		64404,
		19076,
		23558,
		72286
	],
	"6781": [
		77059
	],
	"6996": [
		77059
	],
	"7021": [
		33857
	],
	"7051": [
		64404,
		19076,
		23558,
		72286
	],
	"7123": [
		64404,
		19076,
		23558,
		72286
	],
	"7185": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"7194": [
		64404,
		19076,
		23558,
		72286
	],
	"7290": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"7296": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"7338": [
		77059
	],
	"7382": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"7512": [
		64404,
		19076,
		23558,
		72286,
		93661,
		33857
	],
	"7549": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"7650": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"7782": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"7804": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"8165": [
		64404,
		19076,
		23558,
		72286,
		59743
	],
	"8310": [
		64404,
		19076,
		23558,
		72286,
		33857,
		59743
	],
	"8562": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"8695": [
		64404,
		19076,
		23558,
		72286
	],
	"8735": [
		64404,
		19076,
		23558,
		72286,
		93661,
		33857
	],
	"8754": [
		59743,
		93661,
		64404,
		19076,
		23558,
		72286
	],
	"8792": [
		77059,
		18033
	],
	"8884": [
		77059
	],
	"9031": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"9099": [
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"9314": [
		64404,
		19076,
		23558,
		72286
	],
	"9378": [
		64404,
		19076,
		23558,
		72286,
		35337,
		33857
	],
	"9695": [
		64404,
		19076,
		23558,
		72286
	],
	"9721": [
		93661,
		64404,
		19076,
		23558,
		72286,
		33857
	],
	"9851": [
		59743,
		64404,
		19076,
		23558,
		72286
	],
	"9911": [
		64404,
		19076,
		23558,
		72286,
		59743
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}